import React, { useState, useEffect } from "react";
import "../styles/EcoWaterReport.css"; // Import the CSS file
import OSS from "ali-oss";
import config from "../config";

const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  return d.toISOString().split("T")[0];
};

function EcoWaterReport() {
  const [departments, setDepartments] = useState([]);
  const [reportStatus, setReportStatus] = useState("");
  const [formData, setFormData] = useState({
    lab_name: "",
    sent_name: "项目现场",
    project_name: "",
    technician_name: "宫主",
    address: "江苏省常州市天宁区省岸里161号",
    audit_name: "钱驰名",
    phone: "0519-81235599",
    temperature: 50,
    collect_date: null,
    analyze_date: null,
    project_type: "O",
    raw_data: {},
  });

  const [waterItems, setWaterItems] = useState({
    item1: "",
    item2: "",
    item3: "",
    item4: "",
    item5: "",
    item6: "",
  });

  const parameters = [
    { id: "ph", label: "pH", hasVolume: false },
    { id: "con_val", label: "电导率", hasVolume: false },
    { id: "ca_val", label: "钙硬度", hasVolume: true, volumeId: "ca_vol" },
    { id: "hn_val", label: "总硬度", hasVolume: true, volumeId: "hn_vol" },
    { id: "alk_val", label: "总碱度", hasVolume: true, volumeId: "alk_vol" },
    { id: "cl_val", label: "氯离子", hasVolume: true, volumeId: "cl_vol" },
    { id: "p_val", label: "总磷", hasVolume: true, volumeId: "p_vol" },
    { id: "tur_val", label: "浊度", hasVolume: false },
    { id: "ptsa", label: "PTSA", hasVolume: false },
  ];

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const url = `${config.apiUrl}/params/`;
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "SD-API-KEY": config.apiKey,
            "Content-Type": "application/json",
          },
          mode: "cors",
          credentials: "include",
          cache: "no-cache",
        });

        const data = await response.json();
        setDepartments(data);
      } catch (error) {
        console.error("Error fetching departments:", error);
        setDepartments([
          {
            department_name: "常州申度",
            alk: "0.44",
            ca: "0.09",
            cl: "0.98",
            p: "0.40",
          },
        ]);
      }
    };
    fetchDepartments();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const raw_data = {};
    Object.entries(waterItems).forEach(([key, value]) => {
      if (value) {
        raw_data[value] = parameters.map((param) => {
          const baseValue = {
            [`${param.id}`]: formData.raw_data[key]?.[param.id] || "",
          };
          if (param.hasVolume) {
            baseValue[param.volumeId] =
              formData.raw_data[key]?.[param.volumeId] || 15;
          }
          return baseValue;
        });
      }
    });

    const analyzeDate = formatDate(formData.analyze_date);
    const payload = {
      ...formData,
      raw_data,
      id: `${analyzeDate}${formData.project_name}`,
      date: analyzeDate,
      collect_date: formatDate(formData.collect_date),
      analyze_date: analyzeDate,
    };

    try {
      const response = await fetch(`${config.apiUrl}/water_report/`, {
        method: "POST",
        headers: {
          "SD-API-KEY": config.apiKey,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
        mode: "cors",
        credentials: "include",
      });
      if (response.ok) {
        console.log("Report submitted successfully");
      }
    } catch (error) {
      console.error("Error submitting report:", error);
    }

    const client = new OSS({
      region: "oss-cn-shanghai", // Replace with your OSS region
      accessKeyId: "LTAI5tM2ayTvgBvnRncSFYCm", // Replace with your access key ID
      accessKeySecret: "9fMRmUwM66ulHFrTZWsMtedxxzv7Di", // Replace with your access key secret
      bucket: "sendonet-wa", // Replace with your bucket name
    });

    const report_id = `${formData.analyze_date}${formData.project_name}`;
    const url = client.signatureUrl(report_id, {
      expires: 3600, // URL expires in 1 hour
      method: "GET",
    });
    console.log(url);

    setReportStatus("报告生成成功！正在下载报告...");
    try {
      // Fetch the report file from OSS
      const result = await client.get(`wa_report/${report_id}.docx`);

      // Create a download link
      const downloadUrl = URL.createObjectURL(
        new Blob([result.content], { type: "application/docx" })
      );

      console.log(downloadUrl);

      // Trigger the download
      const fileLink = document.createElement("a");
      fileLink.href = downloadUrl;
      fileLink.download = `${report_id}.docx`;
      fileLink.click();

      // Update status
      setReportStatus("下载报告完成！");
    } catch (err) {
      console.error("下载报告失败:", err);
      setReportStatus("下载报告失败，请重试！");
    }
  };

  return (
    <div className="form-container">
      <form onSubmit={handleSubmit}>
        <div className="form-section">
          <div className="form-row">
            <div className="form-group">
              <label>实验室名称</label>
              <select
                value={formData.lab_name}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, lab_name: e.target.value }))
                }
              >
                <option value="">选择实验室</option>
                {departments.map((dept) => (
                  <option
                    key={dept.department_name}
                    value={dept.department_name}
                  >
                    {dept.department_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>寄/送样人</label>
              <input
                type="text"
                value={formData.sent_name}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    sent_name: e.target.value,
                  }))
                }
              />
            </div>
            <div className="form-group">
              <label>检验人</label>
              <input
                type="text"
                value={formData.technician_name}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    technician_name: e.target.value,
                  }))
                }
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>取样日期</label>
              <input
                type="date"
                value={formData.collect_date || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    collect_date: e.target.value,
                  }))
                }
              />
            </div>
            <div className="form-group">
              <label>化验日期</label>
              <input
                type="date"
                value={formData.analyze_date || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    analyze_date: e.target.value,
                  }))
                }
              />
            </div>
            <div className="form-group">
              <label>项目性质</label>
              <select
                value={formData.project_type}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    project_type: e.target.value,
                  }))
                }
              >
                <option value="O">现有项目</option>
                <option value="N">新项目</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>项目名称</label>
              <input
                type="text"
                value={formData.project_name}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    project_name: e.target.value,
                  }))
                }
              />
            </div>
            <div className="form-group">
              <label>换热温度</label>
              <input
                type="number"
                value={formData.temperature}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    temperature: e.target.value,
                  }))
                }
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group full-width">
              <label>地址</label>
              <input
                type="text"
                value={formData.address}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, address: e.target.value }))
                }
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>电话</label>
              <input
                type="text"
                value={formData.phone}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, phone: e.target.value }))
                }
              />
            </div>
            <div className="form-group">
              <label>审核</label>
              <input
                type="text"
                value={formData.audit_name}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    audit_name: e.target.value,
                  }))
                }
              />
            </div>
          </div>
        </div>

        <div className="water-samples-section">
          <h2>水样参数</h2>
          <table className="water-samples-table">
            <thead>
              <tr>
                <th>参数</th>
                {[1, 2, 3, 4, 5, 6].map((index) => (
                  <th key={index}>
                    <input
                      type="text"
                      value={waterItems[`item${index}`]}
                      onChange={(e) => {
                        const newWaterItems = { ...waterItems };
                        newWaterItems[`item${index}`] = e.target.value;
                        setWaterItems(newWaterItems);
                      }}
                      placeholder={`水样${index}`}
                    />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {parameters.map((param) => (
                <tr key={param.id}>
                  <td>{param.label}</td>
                  {[1, 2, 3, 4, 5, 6].map((index) => (
                    <td key={index}>
                      <input
                        type="number"
                        step="0.1"
                        disabled={!waterItems[`item${index}`]}
                        value={
                          formData.raw_data[`item${index}`]?.[param.id] || ""
                        }
                        onChange={(e) => {
                          const newFormData = { ...formData };
                          if (!newFormData.raw_data[`item${index}`]) {
                            newFormData.raw_data[`item${index}`] = {};
                          }
                          newFormData.raw_data[`item${index}`][param.id] =
                            e.target.value;
                          setFormData(newFormData);
                        }}
                        placeholder="值"
                      />
                      {param.hasVolume && (
                        <input
                          type="number"
                          disabled={!waterItems[`item${index}`]}
                          value={
                            formData.raw_data[`item${index}`]?.[
                              param.volumeId
                            ] || 15
                          }
                          onChange={(e) => {
                            const newFormData = { ...formData };
                            if (!newFormData.raw_data[`item${index}`]) {
                              newFormData.raw_data[`item${index}`] = {};
                            }
                            newFormData.raw_data[`item${index}`][
                              param.volumeId
                            ] = e.target.value;
                            setFormData(newFormData);
                          }}
                          placeholder="体积"
                        />
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="form-footer">
          <button type="submit">提交</button>
        </div>
      </form>
      {reportStatus && <p>{reportStatus}</p>}
    </div>
  );
}

export default EcoWaterReport;
